// cardOrder.js – Reihenfolge der Karten (Vorschau und Druck) und Extrakarten-Plan
// Zuerst die mehrfarbigen Karten (oberste Generation), dann jede Familie (Farbe) nach Alter.
import { computeLayout } from './treeLayout';
import { cheapestPacks } from './pricing';
import { planExtras } from './extraCards';

// Ältere zuerst; ohne Geburtsdatum ans Ende der Gruppe
function byAge(pos) {
  return (a, b) => {
    const da = a.birthDate || '', db = b.birthDate || '';
    if (da && db && da !== db) return da < db ? -1 : 1;
    if (!da !== !db) return da ? -1 : 1;
    return (pos.get(a.id)?.x ?? 0) - (pos.get(b.id)?.x ?? 0);
  };
}

/**
 * Sortiert die Personen für die Karten.
 * colors: Ergebnis von computeColorSystem
 * Rückgabe: { ordered, familyColors }
 */
export function orderPersonsForCards(persons, relationships, colors) {
  const pos = computeLayout(persons, relationships);
  const sort = byAge(pos);
  const multi = [], byColor = new Map(), rest = [];
  persons.forEach(p => {
    const ci = colors.get(p.id);
    if (ci?.color) {
      if (!byColor.has(ci.color)) byColor.set(ci.color, []);
      byColor.get(ci.color).push(p);
    } else if (ci?.borderColors?.length) multi.push(p);
    else rest.push(p);
  });
  // Familien in der Reihenfolge, in der ihre Farben auf den mehrfarbigen Karten vorkommen
  const familyColors = [];
  multi.sort(sort).forEach(p => (colors.get(p.id).borderColors || []).forEach(c => {
    if (byColor.has(c) && !familyColors.includes(c)) familyColors.push(c);
  }));
  [...byColor.keys()].forEach(c => { if (!familyColors.includes(c)) familyColors.push(c); });

  const ordered = [...multi];
  familyColors.forEach(c => ordered.push(...byColor.get(c).sort(sort)));
  ordered.push(...rest.sort(sort));
  return { ordered, familyColors };
}

// Extrakarten für die Schachtel(n) dieses Stammbaumes
export function extraPlanFor(personCount, familyColors) {
  const { packs } = cheapestPacks(personCount);
  const capacity = packs.reduce((s, p) => s + p.size, 0);
  return { packs, capacity, ...planExtras({ persons: personCount, capacity, familyColors }) };
}
